export class ConfigTSLI {

    //timer of automatic save (in millisecondes)
    static readonly AUTO_SAVE_TIMER: number = 10000;

}